import { useTranslation } from "react-i18next";

import { Table, UnstyledButton } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Card } from "@prostocheck/ui";

import { IZReportsTableProps } from "./z-reports-table.models";

export const ZReportsTable = ({ reports, onSelectReport }: IZReportsTableProps) => {
  const { t } = useTranslation();
  const { formatDateTime, formatNumber, formatPrice } = useFormatters();

  return (
    <Card className="p-0">
      <Table.ScrollContainer minWidth={720}>
        <Table highlightOnHover verticalSpacing="sm" horizontalSpacing="md">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("register.zReportsColumns.period")}</Table.Th>
              <Table.Th>{t("register.zReportsColumns.shift")}</Table.Th>
              <Table.Th ta="right">{t("zReport.sales")}</Table.Th>
              <Table.Th ta="right">{t("zReport.returns")}</Table.Th>
              <Table.Th ta="right">{t("zReport.net")}</Table.Th>
              <Table.Th ta="right">{t("zReport.receiptsCount")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {reports.map(report => (
              <Table.Tr key={report.fiscalNumber}>
                <Table.Td c="dimmed">
                  {formatDateTime(report.openedAt)} — {formatDateTime(report.closedAt)}
                </Table.Td>
                <Table.Td>
                  <UnstyledButton
                    onClick={() => onSelectReport(report.fiscalNumber)}
                    className="font-medium text-ink-900 hover:text-brand-700"
                  >
                    {t("zReport.shift", { number: formatNumber(report.shiftNumber) })}
                  </UnstyledButton>
                </Table.Td>
                <Table.Td ta="right">{formatPrice(report.salesTotal)}</Table.Td>
                <Table.Td ta="right">{formatPrice(report.returnsTotal)}</Table.Td>
                <Table.Td ta="right" fw={500} c="brand.7">
                  {formatPrice(report.salesTotal - report.returnsTotal)}
                </Table.Td>
                <Table.Td ta="right" c="dimmed">
                  {formatNumber(report.salesCount + report.returnsCount)}
                </Table.Td>
              </Table.Tr>
            ))}
            {reports.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={6} c="dimmed" ta="center" py={40}>
                  {t("register.noZReports")}
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  );
};
